/// <reference path='../../modules/app.module.ts'/>
/// <reference path="../../controllers/shell.controller.ts" />
/// <reference path="../../controllers/appointment.controller.ts" />

module App {
    var getRoutes = (): App.Interfaces.ICustomState[] => {
        var route: App.Interfaces.ICustomState = {
            name: Constants.routeKeys.appointment,
            url: '/' + 'appointment',
            cache: false,
            title: 'Locatie en tijd',
            headerTitle: 'Locatie en tijd',
            configuratorStepName: ['TimeStep', 'TyreDayDateStep', 'SeasonDateStep'],
            order: 4,
            operations: ['SetTime'],
            views: {
                [Constants.viewRegions.appContent]: {
                    templateUrl: '/templates/appointment.html',
                    controller: Controllers.AppointmentController.controllerId + ' as vm'
                }
            },
            showInMenu: true
    }

        return [route];
    }

    function appRun(routehelper: Blocks.Interfaces.IRouterFactory) {
        routehelper.configureRoutes(getRoutes());
    }

    App.Core.appCore.run(appRun);
}